export const resolveEmployeeStatus = (userData) => {
  if (!userData) return undefined;
  return userData.employeeStatus || (userData.companyName ? "approved" : undefined);
};
